import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'gsp-toast-banner-warning',
  templateUrl: './toast-banner-warning.component.html',
  styleUrls: ['./toast-banner-warning.component.scss']
})
export class ToastBannerWarningComponent implements OnInit {
  @Input() headerText: string;
  @Input() subHeaderText: string;
  ngOnInit() { }
}